import { UploadedFile } from '@paragon/component-processor';
import { addSpinnerMessage, removeSpinnerMessage } from '@paragon/task-spinner';

import { countComponents, countMaterials } from '../data/convertCompareCount';
import { prepareFileDataForUpload } from './files';
import { AsyncThunkActionVoid } from './thunkActions';

export const countMaterialsFromFiles =
  (fileData: readonly UploadedFile[]): AsyncThunkActionVoid =>
  async (dispatch) => {
    const spinnerId = dispatch(addSpinnerMessage('Counting files...'));

    const transformedFileData = await prepareFileDataForUpload(fileData);
    try {
      const countResults = await countMaterials(transformedFileData);
      await countResults.downloadWithName(`materials.${fileData.map((file) => file.filename).join('.')}.csv`);
    } catch (error) {
      console.error(error);
      alert('Error counting.');
    } finally {
      dispatch(removeSpinnerMessage(spinnerId));
    }
  };

export const countComponentsFromFiles =
  (fileData: readonly UploadedFile[]): AsyncThunkActionVoid =>
  async (dispatch) => {
    const spinnerId = dispatch(addSpinnerMessage('Counting files...'));

    const transformedFileData = await prepareFileDataForUpload(fileData);
    try {
      const countResults = await countComponents(transformedFileData);
      await countResults.downloadWithName(`components.${fileData.map((file) => file.filename).join('.')}.csv`);
    } catch (error) {
      console.error(error);
      alert('Error counting.');
    } finally {
      dispatch(removeSpinnerMessage(spinnerId));
    }
  };
